<div class="project-logbook-properties">

  <ng-container [ngSwitch]="event.type">
    <!-- FILES SENT EVENT PROPERTIES -->
    <div class="files-sent" *ngSwitchCase="FILES_SENT">
      <div class="requester">
        <!-- Recipient of the email  -->
        <core-helper-box-header-user-date
          [user]="properties.recipient"
          [preText]="preText"
        ></core-helper-box-header-user-date>
      </div>
      <div class="details-main">
        <div class="details">
          <div class="subject"><em>Subject:</em> <span>{{getEmailDetail('subject')}}</span></div>
          <div class="message" [innerHTML]="getEmailDetail('message')">{{getEmailDetail('message')}}</div>
        </div>
        <div class="files-sent-main">
            <core-files-list-notes-item
              [file]="properties.file"
              [menu]="fileMenu"
              (menuClick)="onFileMenuClick($event)"
              (iconDownloadClick)="onActionDownloadClick($event)" 
              (actionClick)="onFileClickPreview($event)"
            ></core-files-list-notes-item>
        </div>
      </div>
    </div>
    <!-- FEEDBACK REQUEST EVENT PROPERTIES -->
    <div class="feedback-request" *ngSwitchCase="FEEDBACK_REQUEST">
      <div class="requester">
        <!-- TODO Load the recipient of the email  -->
        <core-helper-box-header-user-date
        [user]="properties.recipient"
        [preText]="preText"
        ></core-helper-box-header-user-date>
      </div>
      <div class="details-main">
        <div class="details">
          <div class="subject"><em>Subject:</em> <span>{{getEmailDetail('subject')}}</span></div>
          <div class="message" [innerHTML]="getEmailDetail('message')">{{getEmailDetail('message')}}</div>
        </div>
        <div class="artworks">
          <!-- here the versions need to be loaded yet -->
          <h4 *ngIf="properties.version" (click)="toggleArtworks()" [ngClass]="{opened: show}">
            <em>1</em> <span class="arrow-down">Artwork</span>
          </h4>
          <div class="share-artworks" [hidden]="!show" >
            <!-- one single version each share -->
            <core-versions-summary-box
            [version]="properties.version"
            [menu]="menu"
            [versionShares]="versionShares"
            (menuClick)="onMenuClick($event)"
            (actionFileClick)="onClickPreview($event)"
            ></core-versions-summary-box>
          </div>
        </div>
      </div>
    </div>
     <!-- FEEDBACK UPLOAD VERSION REQUEST EVENT PROPERTIES -->
    <div class="feedback-request" *ngSwitchCase="FEEDBACK_UPLOAD_VERSION_REQUEST">
      <div class="requester">
        <!-- TODO Load the recipient of the email  -->
        <core-helper-box-header-user-date
        [user]="properties.recipient"
        [preText]="preText"
        ></core-helper-box-header-user-date>
      </div>
      <div class="details-main">
        <div class="details">
          <div class="subject"><em>Subject:</em> <span>{{getEmailDetail('subject')}}</span></div>
          <div class="message" [innerHTML]="getEmailDetail('message')">{{getEmailDetail('message')}}</div>
        </div>
        <div class="artworks">
          <!-- here the versions need to be loaded yet -->
          <h4 *ngIf="properties.version" (click)="toggleArtworks()" [ngClass]="{opened: show}">
            <em>1</em> <span class="arrow-down">Artwork</span>
          </h4>
          <div class="share-artworks" [hidden]="!show" >
            <!-- one single version each share [feedbacks]="feedbacks"-->
            <core-versions-summary-box
              [version]="properties.version"
              [menu]="menu"
              [versionShares]="versionShares"
              (menuClick)="onMenuClick($event)"
              (actionFileClick)="onClickPreview($event)"
            ></core-versions-summary-box>
          </div>
        </div>
      </div>
    </div>
    <!-- TO REVIEW ng17 when no ngSwitchDefault due to strict comparison -->
  </ng-container>
</div>
